import { useEffect, useRef } from 'react';
import { noop } from 'functions/noop';

export const useEventListener = (eventName, handler, element, eventListenerOptions) => {
  // Create a ref that stores handler
  const savedHandler = useRef();

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      const targetElement = element?.current ?? window;
      if (!(targetElement && targetElement.addEventListener)) {
        return noop;
      }

      // Create event listener that calls handler function stored in ref
      const eventListener = (event) => savedHandler.current(event);
      // Add event listener
      targetElement.addEventListener(eventName, eventListener, eventListenerOptions);
      // Remove event listener on cleanup
      return () => {
        targetElement.removeEventListener(eventName, eventListener, eventListenerOptions);
      };
    },
    [eventName, element, eventListenerOptions], // Re-run if eventName or element changes
  );
};
